/**
 * Created by daniel on 17/04/17.
 *
 * Component acts as a host for TableItems or BlockItems
 *
 * Can only be placed inside TableItems
 *
 * Generally I don't screw with the styles on these. Only alignment needs dealing with.
 *
 */

import React, {Component} from 'react';
import StyleItem from "./StyleItem";
import DropZone from "../ui/DropZone";
import * as _ from "lodash/object";

class MainRowItem extends Component {
  render() {
    return (
      <tr
        id={this.props.contentId}
        className={[this.props.contentId, this.props.viewClass].join(" ").trim()}
        ref={(node) => {
          let attrs = {
            align: "center",
            valign: "top",
            draggable: true,
          };
          _.toPairs(attrs).map((item) => {
            return node && node.setAttribute(item[0], item[1]);
          });
        }}
        {...this.props.eventHandlers}
      >
        <StyleItem selectorPrefix={this.props.contentId + " "} styleObject={this.props.viewCss}/>
        
        <td
          ref={(node) => {
            let attrs = {
              align: "center",
              valign: "top",
            };
            _.toPairs(attrs).map((item) => {
              return node && node.setAttribute(item[0], item[1]);
            });
          }}
        >
          <table
            className="full-width"
            ref={(node) => {
              let attrs = {
                border: 0,
                cellpadding: 0,
                cellspacing: 0,
              };
              _.toPairs(attrs).map((item) => {
                return node && node.setAttribute(item[0], item[1]);
              });
            }}
          >
            <tbody>
            <tr
              ref={(node) => {
                let attrs = {
                  align: "center",
                  valign: "top",
                };
                _.toPairs(attrs).map((item) => {
                  return node && node.setAttribute(item[0], item[1]);
                });
              }}
            >
              <td
                ref={(node) => {
                  let attrs = {
                    align: "center",
                    valign: "top",
                  };
                  _.toPairs(attrs).map((item) => {
                    return node && node.setAttribute(item[0], item[1]);
                  });
                }}
              >
                <table
                  className="section-content-container"
                  ref={(node) => {
                    let attrs = {
                      border: 0,
                      cellpadding: 0,
                      cellspacing: 0,
                    };
                    _.toPairs(attrs).map((item) => {
                      return node && node.setAttribute(item[0], item[1]);
                    });
                  }}
                  style={{
                    width: this.props.styleWidth,
                    height: this.props.styleHeight,
                    padding: this.props.stylePadding,
                    backgroundColor: this.props.styleBackgroundColour,
                    color: this.props.styleTextColour,
                    textAlign: this.props.styleTextAlignment,
                  }}
                >
                  <tbody>
                  <tr
                    ref={(node) => {
                      let attrs = {
                        align: "center",
                        valign: "top",
                      };
                      _.toPairs(attrs).map((item) => {
                        return node && node.setAttribute(item[0], item[1]);
                      });
                    }}
                  >
                    {
                      this.props.children.length > 0 ? this.props.children :<td><DropZone text={this.props.configName}/></td>
                    }
                  </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            </tbody>
          </table>
        </td>
        
      </tr>
    );
  }
}

export default MainRowItem;


// WEBPACK FOOTER //
// ./src/App/Editor/components/primitives/MainRow.js